import * as React from 'react';

export const WorkTimeTab = () => {
  return <div>TBA tab content: WorkTimeTab</div>;
};
